/**
 * See: https://github.com/BorisChumichev/everpolate
 * And: http://borischumichev.github.io/everpolate/
 */


/**
 * Makes argument to be an array if it's not
 *
 * @param input
 * @returns {Array}
 */

let makeItArrayIfItsNot = function (input) {
  return Object.prototype.toString.call( input ) !== '[object Array]'
    ? [input]
    : input
}

/**
 *
 * Utilizes bisection method to search an interval to which
 * point belongs to, then returns an index of left border
 * of the interval
 *
 * @param {Number} point
 * @param {Array} intervals
 * @returns {Number}
 */

let findIntervalLeftBorderIndex = function (point, intervals) {
  //If point is beyond given intervals
  if (point < intervals[0])
    return 0;
  if (point > intervals[intervals.length - 1])
    return intervals.length - 1;
  //If point is inside interval
  //Start searching on a full range of intervals
  var leftBorderIndex = 0;
  var rightBorderIndex = intervals.length - 1;
  //Reduce searching range till it find an interval point belongs to using binary search
  while (rightBorderIndex - leftBorderIndex !== 1) {
    var indexOfNumberToCompare = leftBorderIndex + Math.floor((rightBorderIndex - leftBorderIndex)/2);
    point >= intervals[indexOfNumberToCompare]
      ? leftBorderIndex = indexOfNumberToCompare
      : rightBorderIndex = indexOfNumberToCompare;
  }
  return leftBorderIndex;
}

/**
 * Evaluates interpolating line/lines at the set of numbers
 * or at a single number for the function y=f(x)
 *
 * @param {Number|Array} pointsToEvaluate     number or set of numbers
 *                                            for which polynomial is calculated
 * @param {Array} functionValuesX             set of distinct x values
 * @param {Array} functionValuesY             set of distinct y=f(x) values
 * @returns {Array}
 */

let evaluateLinear = function(pointsToEvaluate, functionValuesX, functionValuesY) {
  var results = [];
  pointsToEvaluate = makeItArrayIfItsNot(pointsToEvaluate);
  pointsToEvaluate.forEach(function (point) {
    var index = findIntervalLeftBorderIndex(point, functionValuesX);
    if (index == functionValuesX.length - 1)
      index--;
    results.push(linearInterpolation(point, functionValuesX[index], functionValuesY[index],
        functionValuesX[index + 1], functionValuesY[index + 1]));
  })
  return results;
}

/**
 *
 * Evaluates y-value at given x point for line that passes
 * through the points (x0,y0) and (y1,y1)
 *
 * @param x
 * @param x0
 * @param y0
 * @param x1
 * @param y1
 * @returns {Number}
 */

let linearInterpolation = function(x, x0, y0, x1, y1) {
  var a = (y1 - y0) / (x1 - x0);
  var b = -a * x0 + y0;
  return a * x + b;
}


/**
 * Computes Linear Regression slope, intercept, r-squared and returns
 * a function which can be used for evaluating linear regression
 * at a particular x-value
 *
 * @param functionValuesX {Array}
 * @param functionValuesY {Array}
 * @returns {Object}
 */

function linearRegression(functionValuesX, functionValuesY){
  var regression = {}
    , x = functionValuesX
    , y = functionValuesY
    , n = y.length
    , sum_x = 0
    , sum_y = 0
    , sum_xy = 0
    , sum_xx = 0
    , sum_yy = 0;

  for (var i = 0; i < y.length; i++) {
    sum_x += x[i];
    sum_y += y[i];
    sum_xy += (x[i]*y[i]);
    sum_xx += (x[i]*x[i]);
    sum_yy += (y[i]*y[i]);
  }

  regression.slope = (n * sum_xy - sum_x * sum_y) / (n*sum_xx - sum_x * sum_x);
  regression.intercept = (sum_y - regression.slope * sum_x)/n;
  regression.rSquared = Math.pow((n*sum_xy - sum_x*sum_y)/Math.sqrt((n*sum_xx-sum_x*sum_x)*(n*sum_yy-sum_y*sum_y)),2);
  regression.evaluate = function (pointsToEvaluate) {
    var x = makeItArrayIfItsNot(pointsToEvaluate)
      , result = []
      , that = this;
    x.forEach(function (point) {
      result.push(that.slope*point + that.intercept);
    })
    return result;
  }

  return regression;
}


/**
 * Evaluates interpolating polynomial at the set of numbers
 * or at a single number for the function y=f(x)
 *
 * @param {Number|Array} pointsToEvaluate     number or set of numbers
 *                                            for which polynomial is calculated
 * @param {Array} functionValuesX             set of distinct x values
 * @param {Array} functionValuesY             set of distinct y=f(x) values
 * @returns {Array}                           interpolating polynomial
 */

 let evaluatePolynomial = function(pointsToEvaluate, functionValuesX, functionValuesY) {
  var results = [];
  pointsToEvaluate = makeItArrayIfItsNot(pointsToEvaluate);
  // evaluate the interpolating polynomial for each point
  pointsToEvaluate.forEach(function (point) {
    results.push(nevillesIteratedInterpolation(point, functionValuesX, functionValuesY));
  });
  return results;
}

/**
 * Neville's Iterated Interpolation algorithm implementation
 * http://en.wikipedia.org/wiki/Neville's_algorithm <- for reference
 *
 * @param {Number} x                           number for which polynomial is calculated
 * @param {Array} X                            set of distinct x values
 * @param {Array} Y                            set of distinct y=f(x) values
 * @returns {number}                           interpolating polynomial
 */

let nevillesIteratedInterpolation = function(x, X, Y) {
  var Q = [Y];
  for (var i = 1; i < X.length; i++) {
    Q.push([]);
    for (var j = 1; j <= i; j++) {
      Q[j][i] = ((x-X[i-j])*Q[j-1][i] - (x-X[i])*Q[j-1][i-1])/( X[i] - X[i-j] );
    }
  }
  return Q[j-1][i-1];
}


/**
 * Evaluates interpolating step function at the set of numbers
 * or at a single number
 *
 * @param {Number|Array} pointsToEvaluate     number or set of numbers
 *                                            for which step is calculated
 * @param {Array} functionValuesX             set of distinct x values
 * @param {Array} functionValuesY             set of distinct y=f(x) values
 * @returns {Array}
 */

let step = function(pointsToEvaluate, functionValuesX, functionValuesY) {
  var results = [];
  pointsToEvaluate = makeItArrayIfItsNot(pointsToEvaluate);
  pointsToEvaluate.forEach(function (point) {
    results.push(functionValuesY[findIntervalLeftBorderIndex(point, functionValuesX)]);
  })
  return results;
}

export {evaluatePolynomial as polynomial, evaluateLinear as linear, linearRegression, step};
